import { app } from '../../../../../../app';
import { Controller } from './import-accounts-to-group.controller';

app.component('companyUserDirectoriesManageGroupAccountsImport', {
    bindings: {
        companyId: '<',
        group: '<',
    },
    controller: Controller,
    templateUrl: require('./import-accounts-to-group.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/import/import-accounts-to-group.component.js